import React from 'react';

export const FloatingVerticalDivider = () => (
  <div tw="w-px h-5 bg-gray-200 mx-2" />
);
